import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import CryptoJS from "crypto-js";
import { useTranslation } from "react-i18next";

// initial state
export const initialState = {
  loading: false,
  loadingOrderList: false,
  error: null,
  Provinces: null,
  CurrentLawFirmID: null,
  CurrentLawyerID: null,
  CurrentOrders: null,
  CurrentOrderList: [],
  totalOrderCount: 0,
  lawyersByFirm: [],
  firmDetails: null,
  AllFirmDetails: null,
  lawyerDetails: null,
  DashboardLawfirm: {},
  IsDashBoardLawfirmSelected: false,
  FileFirmDetails: null,
  lawyersByAssistant: null,
  multipleFirmsUser: false,
  multipleLawFirms: [],
  isCurrentFirmPromptFinancial: false,
};



// our slice
const lawFirmSlice = createSlice({
  name: "lawFirm",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setLoadingOrderList: (state) => {
      state.loadingOrderList = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    getProvinces: (state, { payload }) => {
      state.loading = false;
      state.Provinces = payload;
      state.error = null;
    },
    getCurrentOrders: (state, { payload }) => {
      state.loading = false;
      state.CurrentOrders = payload;
      state.error = null;
    },
    setCurrentOrderList: (state, { payload }) => {
      if (!payload.isfilter) state.CurrentOrderList = payload;
      else {
        if (payload.tab === 1) {
          state.CurrentOrderList.lstOrdersOverView = payload.lstOrdersOverView;
          state.totalOrderCount=payload.lstOrdersOverView[0]?.totalRows;
        } else if (payload.tab === 2) {
          state.CurrentOrderList.lstOrdersPending = payload.lstOrdersPending;
          state.totalOrderCount=payload.lstOrdersPending[0]?.totalRows;

        } else if (payload.tab === 3) {
          state.CurrentOrderList.lstOrdersReadyForPick =
            payload.lstOrdersReadyForPick;
          state.totalOrderCount=payload.lstOrdersReadyForPick[0]?.totalRows;

        }
      }
      // // Store total count if available from API
      // if (payload.totalCount !== undefined) {
      //   state.totalOrderCount = payload.totalCount;
      // }
      state.loadingOrderList = false;
      state.error = null;
    },
    setLawyersByFirmID: (state, { payload }) => {
      state.loading = false;
      state.lawyersByFirm = payload;
      state.error = null;
    },
    setFirmDetails: (state, { payload }) => {
      state.firmDetails = payload;
    },
    setAllFirmDetails: (state, { payload }) => {
      state.AllFirmDetails = payload;
    },
    setDashboardLawfirm: (state, { payload }) => {
      state.DashboardLawfirm = payload;
      window.localStorage.setItem(
        "dashboardLawFirm",
        CryptoJS.AES.encrypt(
          JSON.stringify(payload),
          process.env.REACT_APP_CRYPTO_KEY
        ).toString()
      );
    },
    setIsDashBoardLawfirmSelected: (state, { payload }) => {
      state.IsDashBoardLawfirmSelected = payload;
    },
    setFileFirmDetails: (state, { payload }) => {
      state.FileFirmDetails = payload;
    },
    setlawyersByAssistant: (state, { payload }) => {
      state.lawyersByAssistant = payload;
    },
    setlawyerDetails: (state, { payload }) => {
      state.loading = false;
      state.lawyerDetails = payload;
      state.error = null;
    },
    setMultipleFirmsUser: (state, { payload }) => {
      state.multipleFirmsUser = payload;
    },
    setMultipleLawFirms: (state, { payload }) => {
      state.multipleLawFirms = payload;
    },
    setIsCurrentFirmPromptFinancial: (state, { payload }) => {
      state.isCurrentFirmPromptFinancial = payload?.isPromptFinancial;
    },
  },
});
// export the actions
export const {
  setLoading,
  getProvinces,
  setError,
  getCurrentOrders,
  setCurrentOrderList,
  setLawyersByFirmID,
  setLoadingOrderList,
  setFirmDetails,
  setlawyerDetails,
  setAllFirmDetails,
  setDashboardLawfirm,
  setIsDashBoardLawfirmSelected,
  setFileFirmDetails,
  setlawyersByAssistant,
  setMultipleFirmsUser,
  setMultipleLawFirms,
  setIsCurrentFirmPromptFinancial,
} = lawFirmSlice.actions;

// export the default reducer
export default lawFirmSlice.reducer;

// export the selector for fetching the global state
export const lawFirmSelector = (state) => state.lawFirm;

export const GetFirmByFileID = (fileID, userid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: fileID,
    };

    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("Lawfirm/GetFirmByFileID", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      // dispatch(setSuccess());
      dispatch(setFileFirmDetails(results.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const CreateLawyerHistory =
  (lawyerID, modifiedby, Subject, ChangeType, ChangeDescription, Extravalue) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        LawyerId: lawyerID,
        ModifiedBy: modifiedby,
        Subject: Subject,
        ChangeType: ChangeType,
        ChangeDescription: ChangeDescription,
        ExtraValue: Extravalue,
      };

      let req = { UserID: modifiedby, RequestObject: request };
      const results = await http
        .post("Lawfirm/CreateLawyerHistory", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        // dispatch(setSuccess());
        // dispatch(setFileFirmDetails(results.data.responseObject));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
export const CreateLawfirmHistory =
  (FirmID, modifiedby, Subject, ChangeType, ChangeDescription, Extravalue) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        FirmID: FirmID,
        ModifiedBy: modifiedby,
        Subject: Subject,
        ChangeType: ChangeType,
        ChangeDescription: ChangeDescription,
        ExtraValue: Extravalue,
      };

      let req = { UserID: modifiedby, RequestObject: request };
      const results = await http
        .post("Lawfirm/CreateLawfirmHistory", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        // dispatch(setSuccess());
        // dispatch(setFileFirmDetails(results.data.responseObject));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

// Get Province API call
export const GetProvinceDetails = (countryOrder) => async (dispatch) => {
  try {
    dispatch(setLoading());

    var GetProvincesReq = {
      CountryOrder: countryOrder,
    };
    let result = await http.post("Lawfirm/GetProvinces", GetProvincesReq);
    dispatch(getProvinces(result.data.responseObject.provinces));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
// Get current orders API call
export const GetCurrentOrders = (firmID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var GetProvincesReq = {
      firmID: firmID,
    };
    let result = await http.post("Lawfirm/GetOrderStatus", GetProvincesReq);
    dispatch(getCurrentOrderList(result.data.responseObject.orders));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetCurrentOrderList =
  (
    firmID,
    tab,
    date,
    deal,
    lawyer,
    status,
    text,
    isfilter,
    sortby,
    sortType,
    assistantID,
    pageNumber = 1,
    pageSize = 10
  ) =>
  async (dispatch) => {
    console.log("firmiD", firmID);
    try {
      dispatch(setLoadingOrderList());

      var sortcolumn = "";
      switch (sortby) {
        case "fileNumber": {
          sortcolumn = "filenumber";
          break;
        }
        case "internalReference": {
          sortcolumn = "internalReference";
          break;
        }
        case "lawyerName": {
          sortcolumn = "lawyerName";
          break;
        }
        case "dealType": {
          sortcolumn = "tb.dealType";
          break;
        }
        case "closingDate": {
          sortcolumn = "tb.closingDate";
          break;
        }
        case "status": {
          sortcolumn = "tb.status";
          break;
        }
        default: {
          sortcolumn = "filenumber";
          break;
        }
      }
      var sortdirection = sortType === "ascending" ? "ASC" : "DESC";
      if (sortcolumn === "") sortdirection = "";
      var req = {
        FirmID: firmID,
        Status: status === "0" ? "" : status,
        LawyerID: lawyer.toString() === "0"|| lawyer.toString() === "All" ? "" : lawyer.toString(),
        DealType: deal === "0" ? "All" : deal,
        ClosingDate: date,
        SearchText: text,
        OrderBy: sortcolumn,
        OrderValue: sortdirection,
        PageNumber: Number.isFinite(pageNumber) ? pageNumber : 1,
        PageSize: pageSize,

        AssistantID:
          assistantID === undefined ||
          assistantID === null ||
          assistantID.toString() === "0"
            ? ""
            : assistantID.toString(),
      };
      let result = await http.post("Order/GetOrderList", req);
      result.data.responseObject.isfilter = isfilter;
      result.data.responseObject.tab = tab;
      if (result.data.responseCode == 0 && firmID) {
        dispatch(setCurrentOrderList(result.data.responseObject));
        console.log("current order list",CurrentOrderList);
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetLawyersByFirmID = (FirmID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FirmID: FirmID,
    };

    const results = await http
      .post("Lawfirm/GetLawyersByFirmID", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setLawyersByFirmID(results.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetIsCurrentFirmPromptFinancial = (FirmID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FirmID: FirmID,
    };

    const results = await http
      .post("Lawfirm/GetIsCurrentFirmPromptFinancial", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setIsCurrentFirmPromptFinancial(results.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLawyersByAssistant = (AssistantId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      AssistantID: AssistantId,
    };

    const results = await http
      .post("Lawfirm/GetLawyersByAssistant", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      // dispatch(setSuccess());
      dispatch(
        setlawyersByAssistant(results.data.responseObject.lawyerDetails)
      );
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLawFirmsByName = (firmName) => async (dispatch) => {
  try {
    dispatch(setLoading());

    let req = {
      NameFilter: firmName,
    };
    let { data: response } = await http.post("/Lawfirm/FindLawFirms", req);
    if (response.responseCode == 0) {
      dispatch(setFirmDetails(response.responseObject.lawfirms));
    } else {
      dispatch(setError(response.responseDescription));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLawfirmsByNameExpress =
  (firmName, ActiveFilter = false) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());

      let req = {
        NameFilter: firmName,
        ActiveFilter: ActiveFilter,
      };
      let { data: response } = await http.post(
        "/Lawfirm/GetLawfirmsByNameExpress",
        req
      );
      if (response.responseCode == 0) {
        dispatch(setAllFirmDetails(response.responseObject.lawfirms));
      } else {
        dispatch(setError(response.responseDescription));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetLawyer = (lawyerID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      lawyerId: lawyerID,
    };

    const results = await http.post("Lawfirm/GetLawyer", req).then((result) => {
      return result;
    });

    if (results.data.responseCode == 0) {
      dispatch(setlawyerDetails(results.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
